import { MutationTree } from 'vuex';
import { IDocumentSettingsState } from '../stores/document-settings.store';
import { IDocumentSettings } from '@/types/DocumentSettings';

export const mutationSetSettings = 'setSettings';

export const mutations: MutationTree<IDocumentSettingsState> = {
  [mutationSetSettings](state, payload: IDocumentSettings) {
    state.settings = payload;
  },
};
